/** Loader de marca (brand book SOA 10 PRO): una ficha encendida por vez, 220 ms cada una (brand book 5). Respeta «reducir movimiento». */
const FICHAS = ["#22D3EE", "#10B981", "#8B5CF6", "#F59E0B"];

export default function BrandLoader({ texto = "Cargando…", className = "py-20" }) {
  return (
    <div role="status" aria-live="polite" className={`flex flex-col items-center justify-center gap-4 ${className}`}>
      <div className="grid grid-cols-2 gap-2" aria-hidden="true">
        {FICHAS.map((c, i) => (
          <span key={c} className="brand-ficha block h-[22px] w-[22px] rounded-[7px]" style={{ background: c, animationDelay: `${i * 220}ms` }} />
        ))}
      </div>
      {texto && <p className="text-[15px] font-extrabold text-foreground/80">{texto}</p>}
    </div>
  );
}
